export const getColumnsFramedBoxItems = (componenData) => {
    const items = {};
    items.bgColor = componenData?.fields?.backgroundColour;
    items.title = componenData?.fields?.title;
    items.numOfColumns = componenData?.fields?.gridColumns;
    items.columnItems = componenData?.fields?.elements.map(element => {
        return {
            description: element?.fields?.description,
            title: element?.fields?.title,
            imageTitle: element?.fields?.image?.fields?.title,
            imageUrl: element?.fields?.image?.fields?.file?.url
        };
    });
    return items;
};
